<template>
    <div class="ds-filter-popover">
        <div v-if="search" class="ds-filter-search">
                <base-input v-model="searchText" placeholder="Поиск"></base-input>
            </div>
        <div class="ds-filter-list">
            <div v-for="item in items" :key="item.name" class="ds-filter-option" :class="{ 'ds-filter-option-selected': item.check }">
            <checkbox v-model="item.check" size="sm" layout="inline" @change="emit('check')">
                <span class="ds-filter-option-label">{{ item.name }}</span>
            </checkbox>
        </div>
        </div>

        <div class="ds-filter-footer">
            <div @click="onReset" class="ds-filter-action">Сбросить</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Filter {
    check: boolean,
    name: string
}

interface Props {
    search?: boolean
}

const { search } = defineProps<Props>()

const items = defineModel<Filter[]>()
const emit = defineEmits(['reset', 'check', 'onsearch'])
const searchText = ref('')

const onReset = () => {
    emit('reset')
    emit('check')
}

watch(searchText, () => {emit('onsearch', searchText.value)})
</script>
